import { Component, OnInit } from '@angular/core';
import { LoginService, UserService } from '@inera/common';
import { IDSpinnerModule } from '@inera/ids-angular/components/form/spinner';
import { IDButtonGroupModule } from '@inera/ids-angular/components/button-group';
import { IDButtonModule } from '@inera/ids-angular/components/button';
import { finalize, switchMap } from 'rxjs';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-loggedout',
  standalone: true,
  imports: [IDSpinnerModule, IDButtonGroupModule, IDButtonModule],
  templateUrl: './loggedout.component.html',
  styleUrl: './loggedout.component.scss',
})
export class LoggedoutComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private router: Router,
    private sessionService: SessionService
  ) {}

  isLoading = true;

  ngOnInit(): void {
    this.loginService
      .createLogoutRequest()
      .pipe(
        switchMap(logoutRequest =>
          this.loginService.logout().pipe(
            finalize(() => {
              this.logoutFromIdp(logoutRequest);
            })
          )
        ),
        finalize(() => {
          this.userService.setUser(null);
          this.sessionService.setUser(null);
          this.isLoading = false;
        })
      )
      .subscribe();
  }

  public login() {
    this.router.navigate(['login']);
  }

  public navigateToStart() {
    this.router.navigate(['/']);
  }

  private logoutFromIdp(logoutRequest: LogoutRequest): void {
    window.location.href = logoutRequest.logoutRequestUrl;
  }
}

export interface LogoutRequest {
  logoutRequestUrl: string;
}
